import React, { Component } from "react";

type ProgressAppProps = {
  totalFiles: number;
  gifPath: string;
  onClose: () => void; // Callback per chiudere il componente
};

type ProgressAppState = {
  runningFiles: number;
  elapsedTime: number;
  frameIndex: number;
};

class ProgressApp extends Component<ProgressAppProps, ProgressAppState> {
  private startTime: number;
  private estimatedTime: number;
  private gifRef: React.RefObject<HTMLImageElement| null>;

  constructor(props: ProgressAppProps) {
    super(props);
    this.state = {
      runningFiles: 0,
      elapsedTime: 0,
      frameIndex: 0,
    };
    this.startTime = Date.now();
    this.estimatedTime = props.totalFiles * 30;
    this.gifRef = React.createRef<HTMLImageElement>();
  }

  componentDidMount() {
    this.updateTime();
  }

  updateTime = () => {
    const interval = setInterval(() => {
      this.setState((prevState) => {
        const elapsedTime = Math.floor((Date.now() - this.startTime) / 1000);
        return { 
          elapsedTime, 
          frameIndex: (prevState.frameIndex + 1) % 10 
        };
      });

      // Check if all files are processed
      if (this.state.runningFiles >= this.props.totalFiles) {
        clearInterval(interval);
        this.props.onClose();
      }
    }, 1000);
  };

  formatTime(seconds: number) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return minutes > 0
      ? `${minutes}m ${remainingSeconds}s`
      : `${seconds} s`;
  }

  fileProcessed = () => {
    // Update runningFiles and check if it's time to close
    this.setState(
      (prevState) => ({ runningFiles: prevState.runningFiles + 1 }),
      () => {
        if (this.state.runningFiles >= this.props.totalFiles) {
            this.props.onClose();
        }
      }
    );
  };

  render() {
    const { gifPath } = this.props;
    const { elapsedTime } = this.state;
    
    const containerStyle: React.CSSProperties = {
      display: 'flex',
      flexDirection: 'column',
      minWidth:'18rem',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '2rem',
      padding: '2rem 0', 
    };

    const textSectionStyle: React.CSSProperties = {
      textAlign: 'center',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: '1.5rem', 
    };
    
    const timeBlockStyle: React.CSSProperties = {
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem', 
    };
    
    const labelStyle: React.CSSProperties = {
      fontSize: '0.875rem', 
      fontWeight: 500,
      color: '#6b7280', 
      textTransform: 'uppercase', 
      letterSpacing: '0.1em', 
    };
    
    const estimatedTimeValueStyle: React.CSSProperties = {
      fontSize: '1.6rem', 
      fontWeight: 700, 
      color: '#1f2937', 
    };
    
    const dividerStyle: React.CSSProperties = {
      height: '1px',
      backgroundColor: '#e0e0e0', 
      width: '100%',
    };
    
    const elapsedTimeValueStyle: React.CSSProperties = {
      fontSize: '1.5rem', 
      fontWeight: 600, 
      color: '#0a62b4ff', 
      fontVariantNumeric: 'tabular-nums', 
    };

    return(
      <div style={containerStyle}>
        <div className="gif-container">
          <img
            ref={this.gifRef}
            src={gifPath}
            alt="GIF"
            style={{ animation: "spin 1s steps(10) infinite", maxWidth:'10rem', maxHeight:'10rem' }}
          />
        </div>

        <div style={textSectionStyle}>
          <div style={timeBlockStyle}>
            <p style={labelStyle}>
              Tempo stimato
            </p>
            <p style={estimatedTimeValueStyle}>
              {this.formatTime(this.estimatedTime)}
            </p>
          </div>

          <div style={dividerStyle} />

          <div style={timeBlockStyle}>
            <p style={labelStyle}>
              Tempo trascorso
            </p>
            <p style={elapsedTimeValueStyle}>
              {this.formatTime(elapsedTime)}
            </p>
          </div>
        </div>
      </div>
    )
  }
}


export default ProgressApp;
